export const iconFontAwesomeDesignEyeDropper = (
	<i className="fa-solid fa-eye-dropper"></i>
);
